// Header scroll state: use a stable selector rather than a generated Shopify section ID.
(() => {
  const header = document.querySelector('.shopify-section-group-header-group');
  if (!header) return;

  let scheduled = false;
  let isScrolled = null;

  function updateHeader() {
    scheduled = false;
    const nextState = window.scrollY > 0;
    if (nextState === isScrolled) return;
    header.classList.toggle('user_scroll', nextState);
    isScrolled = nextState;
  }

  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });

  updateHeader();
})();
